/* MISC REVENUE ENGINE
   Computes monthly revenue amounts for user-defined revenue lines.
   Each line has independent growth settings. */

const r2 = n => Math.round(n * 100) / 100;

function computeMiscRevenue(lines, forecastMonths) {
  const result = {};
  if (!lines || !lines.length) return result;

  lines.forEach(line => {
    if (!line.enabled) return;
    const amounts = {};
    const ma = line.monthly_amounts || {};
    const growthType = line.growth_type || 'flat';
    const growthMode = line.growth_mode || 'compounding';

    if (growthType === 'flat') {
      forecastMonths.forEach(m => {
        amounts[m] = r2(parseFloat(ma[m]) || 0);
      });
    } else if (growthType === 'pct') {
      let priorAmt = r2(parseFloat(ma[forecastMonths[0]]) || 0);
      const firstAmt = priorAmt;
      amounts[forecastMonths[0]] = priorAmt;
      for (let i = 1; i < forecastMonths.length; i++) {
        const m = forecastMonths[i];
        const pct = parseFloat(ma[m]) || 0;
        let growth;
        if (growthMode === 'compounding') {
          growth = r2(priorAmt * pct / 100);
        } else {
          growth = r2(firstAmt * pct / 100);
        }
        const amt = r2(priorAmt + growth);
        amounts[m] = amt;
        priorAmt = amt;
      }
    }

    result[line.id] = {
      name: line.name,
      enabled: line.enabled,
      amounts,
      // 5e-2: carry the Path-A route through so runFullModel's deposit sites
      // (the IS overlay + revByLine) can route to an existing historical key.
      // NULL = Path B (synthetic rev_misc_<id>). '' is normalized to null by the
      // write surface (5e-1), but guard here too.
      target_gl_line_key: line.target_gl_line_key || null,
    };
  });

  return result;
}

export { computeMiscRevenue, r2 };
